import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { FaStar } from "react-icons/fa";
import { CiHeart } from "react-icons/ci";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../API/config";
import axios from "axios";
import { IoCartSharp, IoHeart } from "react-icons/io5";
import { message } from "antd";
import { eventManager } from "../EventEmitter";

type Product = {
  _id: string;
  slug: string;
  categories: string;
  dealPrice: string;
  price: string;
  product: string;
  rating: number;
  description: { screenSize: string };
  variants: Variant[];
};

type Variant = {
  _id: string;
  colorCode: string;
  colorImages: string[];
  colorName: string;
  images: string[];
};

const Cards = ({ product }: { product: any }) => {

  const [activeVariant, setActiveVariant] = useState<Record<string, Variant>>(
    {}
  );
  const [userData, setUserData] = useState<any>(null);
 
  
  const [messageApi, contextHolder] = message.useMessage();
  const success = (content: any) => {
    messageApi.open({
      type: "success",
      content: content,
      className: "custom-class",
    });
  };

  const errormessage = (content: any) => {
    messageApi.open({
      type: "error",
      content: content,
      className: "custom-class",
    });
  };
  const navigate = useNavigate();

  const handleNavDetails = (slug: string, categories: string) => {
    navigate(`/product/${categories}/${slug}`);
  };

  const getMe = async () => {
    const token = sessionStorage.getItem("token");
    if(!token){
      message.error("Login required!")
      return
    }
    try {
      const res = await axios.get(`${API_URL}/api/user/getMe`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserData(res.data.user);
    } catch (error) {
      console.log(error);
    }
  };

  const handleWishlist = async (data: any) => {
    const token = sessionStorage.getItem("token");
    if(!token){
      message.error("Login required!")
      return
    }
    try {
      const wishData = {
        productId: data._id,
        variantDetails: {
          storage: data.variants[0].storage,
          colorName: data.variants[0].colorName,
          ramSize: data.variants[0].ramSize,
        },
      };
      await axios.post(`${API_URL}/api/user/wishlist`, wishData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      eventManager.emit("cartUpdated");
      success("Added to Wishlist");
      await getMe();
    } catch (error: any) {
      console.log(error);
      errormessage(error.response.data.message);
    }
  };

  const handleremoveWishlist = async (data: any) => {
    const token = sessionStorage.getItem("token");
    if(!token){
      message.error("Login required!")
      return
    }
    try {
      const wishData = {
        productId: data._id,
        variantId: data.variants[0]._id,
      };

      await axios.delete(`${API_URL}/api/user/wishlist/remove`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: wishData,
      });
      eventManager.emit("cartUpdated");
      success("Removed from Wishlist");
      await getMe();
    } catch (error: any) {
      console.log(error);
      errormessage(error.response.data.message);
    }
  };

  const handleCart = async (data: any) => {
    const token = sessionStorage.getItem("token");
    if(!token){
      message.error("Login required!")
      return
    }
    try {
      const cartData = {
        productId: data._id,
        variantDetails: {
          storage: data.variants[0].storage,
          colorName: data.variants[0].colorName,
          ramSize: data.variants[0].ramSize,
        },
      };
      await axios.post(`${API_URL}/api/user/cart`, cartData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      eventManager.emit("cartUpdated");
      success("Added to Cart");
      await getMe();
    } catch (error: any) {
      console.log(error);
      errormessage(error.response.data.message);
    }
  };

  const handleremoveCart = async (data: any) => {
    const token = sessionStorage.getItem("token");
    if(!token){
      message.error("Login required!")
      return
    }
    try {
      const cartData = {
        productId: data?._id,
        variantDetails: {
          storage: data.variants[0].storage,
          colorName: data.variants[0].colorName,
          ramSize: data.variants[0].ramSize,
        },
      };

      await axios.delete(`${API_URL}/api/user/cart/remove`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: cartData,
      });
      eventManager.emit("cartUpdated");
      success("Removed from Cart");
      await getMe();
    } catch (error: any) {
      console.log(error);
      errormessage(error.response.data.message);
    }
  };




  const isProductInWishlist = (productId: string) => {
    return userData?.wishlist.some((item: any) => item.product === productId);
  };

  const isProductInCart = (productId: string) => {
    return userData?.cart.some((item: any) => item.product === productId);
  };

  useEffect(() => {
    getMe();
  }, []);

  if (!Array.isArray(product)) {
    return <p>No products available.</p>;
  }

  return (
    <>
      {contextHolder}
      {product.map((val) => {
        const dealPrice = parseFloat(val.variants[0].dealPrice);
        const price = parseFloat(val.variants[0].price);
        const discountPercentage = ((price - dealPrice) / price) * 100;
        const activeImage =
          activeVariant[val._id]?.images[0] || val.variants[0].images[0];

        return (
          <div className="col-lg-4 col-md-4 col-sm-6 col-6 py-3" key={val._id}>
            <Card>
              <div
                className="position-relative card-div"
                onClick={() => handleNavDetails(val.slug, val.categories)}
                style={{
                  cursor: "pointer",
                  background:
                    "linear-gradient(180deg, #CECECE 0%, #FFFFFF 41.34%, #CECECE 100%)",
                }}
              >
              <div >
                <Card.Img
                  className="p-0 card-img"
                  variant="top"
                  src={`${
                    activeImage ? activeImage : ""
                  }`}
                 
                />
                </div>
                {discountPercentage > 0 && (
                  <>
                    <img
                      src="/assets/off.png"
                      className="img-fluid offer-badge"
                      alt="Offer Badge"
                    />
                    <span className="offer-percent">
                      {discountPercentage.toFixed()} %
                    </span>
                  </>
                )}
                {isProductInWishlist(val._id) ? (
                  <div
                    className="heart-badge"
                    onClick={() => handleremoveWishlist(val)}
                  >
                    <IoHeart style={{ color: "red" }} />
                  </div>
                ) : (
                  <div
                    className="heart-badge"
                    onClick={() => handleWishlist(val)}
                  >
                    <CiHeart />
                  </div>
                )}
              </div>
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="card-title">{val.product}</h3>
                  <p className="mb-0 card-rating">
                    ({val.rating}
                    <FaStar style={{ color: "#FFE300", marginBottom: "4px" }} />
                    )
                  </p>
                </div>
                <span className="mb-0 spec-card">
                  {[
                    val.description.screenSize,
                    val.description.specialFeature,
                    val.description.displayTech,
                    val.description.battery,
                  ]
                    .filter(Boolean)
                    .join(" / ")}
                </span>

                <div className="pt-2 d-flex justify-content-start align-items-center">
                  {val.variants.map((variant: Variant) => (
                    <div
                      key={variant._id}
                      className={`color-card me-2 ${
                        activeVariant[val._id] === variant
                          ? "color-cardActive"
                          : "color-cardInActive"
                      }`}
                      style={{
                        backgroundColor: variant.colorCode,
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setActiveVariant((prev) => ({
                          ...prev,
                          [val._id]: variant,
                        }))
                      }
                    ></div>
                  ))}
                </div>

                <div className="d-flex justify-content-between align-items-center">
                  {val.variants[0].dealPrice?
                  <p className="card-offprice">
                    ₹ {val.variants[0].dealPrice}{" "}
                    <span>
                      MRP: ₹
                      <span style={{ textDecoration: "line-through" }}>
                        {val.variants[0].price}
                      </span>
                    </span>
                  </p>:<p className="card-offprice">
                      MRP: ₹ {val.variants[0].price}
                  </p>}
                  {isProductInCart(val._id) ? (
                    <Button
                      className="cart-button"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleremoveCart(val)}
                    >
                      <IoCartSharp
                        style={{ color: "white" }}
                       
                      />
                    </Button>
                  ) : (
                    <Button
                      className="cart-button"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleCart(val)}
                    >
                      <AiOutlineShoppingCart  />
                    </Button>
                  )}
                </div>
              </Card.Body>
            </Card>
          </div>
        );
      })}
    </>
  );
};

export default Cards;
